@if (isLoading) {
  <div>
    <mat-progress-spinner
      class="spinner"
      mode="indeterminate"
      diameter="70">
    </mat-progress-spinner>
  </div>
}